import React from 'react';
import LetterTile from './LetterTile.js';
import './LetterPool.css';

const LetterPool = ({
  letters,
  dragOverPool,
  isDraggingFromPool,
  draggedIndex,
  enteringLetters,
  fadingOut,
  onDragStart,
  onDrag,
  onDragEnd,
  onTouchStart,
  onLetterTap,
  onPoolDragOver,
  onPoolDragLeave,
  onDropOnPool
}) => {
  return (
    <div
      className={`letter-pool ${dragOverPool ? 'drag-over' : ''} ${fadingOut ? 'fading-out' : ''}`}
      onDragOver={onPoolDragOver}
      onDragLeave={onPoolDragLeave}
      onDrop={onDropOnPool}
    >
      <div className="letter-pool-grid">
        {Array.from({ length: 18 }, (_, gridIndex) => {
          const letter = letters[gridIndex];

          // Calculate row and column for 3-row layout: 6-6-6
          let row, col;
          if (gridIndex < 6) {
            // First row: positions 0-5
            row = 1;
            col = gridIndex + 1;
          } else if (gridIndex < 12) {
            // Second row: positions 6-11
            row = 2;
            col = (gridIndex - 6) + 1;
          } else {
            // Third row: positions 12-17
            row = 3;
            col = (gridIndex - 12) + 1;
          }

          // Always render a slot with background graphic
          return (
            <div
              key={`slot-${gridIndex}`}
              className="letter-slot"
              style={{
                gridRow: row,
                gridColumn: col
              }}
            >
              {/* Background graphic for all slots */}
              <div className="slot-background" />

              {letter && (
                <LetterTile
                  letter={letter.char}
                  className={`rack-letter ${isDraggingFromPool && draggedIndex === gridIndex ? 'dragging' : ''} ${
                    enteringLetters && enteringLetters.some(entering => entering.index === gridIndex) ? 'entering' : ''
                  }`}
                  draggable={true}
                  onDragStart={(e) => onDragStart(e, gridIndex)}
                  onDrag={onDrag}
                  onDragEnd={onDragEnd}
                  onTouchStart={(e) => onTouchStart(e, gridIndex)}
                  onClick={() => onLetterTap(gridIndex)}
                  isHintRevealed={letter.isHintRevealed || false}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LetterPool;
